
document.addEventListener('DOMContentLoaded', function () {
    if (typeof Swiper != 'undefined') {
        const swiper = new Swiper('.swiper', {
            direction: 'horizontal',
            loop: true,
            slidesPerView: 'auto',
            spaceBetween: 40,

            navigation: {
              nextEl: document.querySelector('.gallery__next'),
              prevEl: document.querySelector('.gallery__previous'),
            }
          });
    }
});
